import { useQueryClient } from "@tanstack/react-query";
import type { FunctionComponent } from "react";
import { useCallback } from "react";

import Sidebar from "~/components/Sidebar/Sidebar.tsx";
import {
	centralInvoiceRecipientQueries,
} from "~/modules/billing/api/centralInvoiceRecipient/centralInvoiceRecipientQueries.ts";
import CreateOrUpdateCentralInvoiceRecipientForm
	from "~/modules/client/components/centralInvoiceRecipient/components/CreateOrUpdateCentralInvoiceRecipientForm.tsx";


type CreateInvoiceRecipientSidebarProps = {
	clientId: string;
	isOpen: boolean;
	onClose: () => void;
};

const CreateCentralInvoiceRecipientSidebar: FunctionComponent<CreateInvoiceRecipientSidebarProps> = ({
	clientId,
	isOpen,
	onClose,
}) => {
	const queryClient = useQueryClient();

	const handleSuccess = useCallback(async () => {
		await queryClient.invalidateQueries({ queryKey: centralInvoiceRecipientQueries.byClient(clientId).queryKey });
		onClose();
	}, [clientId, onClose, queryClient]);
	return (
		<Sidebar closeOnOutsideClick={false}
				 open={isOpen}
				 setOpen={onClose}>
			<>
				<CreateOrUpdateCentralInvoiceRecipientForm
					clientId={clientId}
					onSuccess={handleSuccess}
					onCancelClick={onClose} />
			</>
		</Sidebar>
	);
};

export default CreateCentralInvoiceRecipientSidebar;